import KeenSlider from "keen-slider";
/**
 * Wall editorial slider init and event listeners
 * @param {Element} sliderWrapperEle - main slider wrapper element
 * @param {Element} popupWrapperEle - Popup slider wrapper element
 */
window.wallEditorialInit = function wallEditorialInit(
  sliderWrapperEle,
  popupWrapperEle
) {
  let popupSliderEle = popupWrapperEle?.querySelector(
    ".wall-editorial-popup-slider"
  );
  let editorialPopupTriggerEles = sliderWrapperEle?.querySelectorAll(
    ".wall-editorial-popup-trigger"
  );
  let editorialPopupCloseEle = popupWrapperEle?.querySelector(
    ".close-editorial-popup"
  );

  // init popup slider
  var sliderPopup = new KeenSlider(
    popupSliderEle,
    {
      loop: true,
      slides: { perView: 1 },
      breakpoints: {
        "(min-width: 768px)": {
          slides: { perView: 2, spacing: 32 },
        },
      },
    },
    [wallEditorialNavigation]
  );
  // open popup wall editorial
  editorialPopupTriggerEles.forEach((ele) => {
    ele.addEventListener("click", (e) => {
      let currentIndex = Number(ele.dataset.index);
      // change popup slider active slide
      changePopSliderIndex(currentIndex);
      // show popup slider
      wallEditorialPopupVisibility(true, popupWrapperEle);
    });
  });
  // Popup Close Listener
  editorialPopupCloseEle.addEventListener("click", (e) => {
    wallEditorialPopupVisibility(false, popupWrapperEle);
  });
  /**
   * Change popup slider current active slide
   * @param {Number} index - slide position index
   */
  function changePopSliderIndex(index) {
    sliderPopup.moveToIdx(index, false, {
      duration: 0,
    });
  }
  /**
   * Control element Visibility Show (true) or Hide (false)
   * @param {Boolean} status - Show or hide element
   * @param {Element} ele - Element for visibility control
   */
  function wallEditorialPopupVisibility(status, ele) {
    if (status) {
      ele.classList.remove("hidden");
      document.body.classList.add("lock-scroll");
    } else {
      ele.classList.add("hidden");
      document.body.classList.remove("lock-scroll");
    }
  }
  /**
   * Slider navigation (Only dots)
   * @param {Object} slider - slider object
   */
  function wallEditorialNavigation(slider) {
    let wrapper, dots, arrowLeft, arrowRight;
    let mainSlider = slider.container.classList.contains(
      "wall-editorial-slider"
    );
    let arrowLeftSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.236 2L6 2.608L1.73 7.5H16V8.5H1.73L6 13.391L5.236 14L0 7.999L5.236 2Z" fill="${
      !mainSlider ? "#fff" : "#000"
    }"/>
    </svg>`;
    let arrowRightSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M10.764 2L10 2.608L14.27 7.5H0V8.5H14.27L10 13.391L10.764 14L16 7.999L10.764 2Z" fill="${
      !mainSlider ? "#fff" : "#000"
    }"/>
    </svg>`;
    const observer = new ResizeObserver(function () {
      slider.update();
    });
    function markup(remove) {
      wrapperMarkup(remove);
      dotMarkup(remove);
      arrowMarkup(remove);
    }
    function removeElement(elment) {
      elment.parentNode.removeChild(elment);
    }
    function createDiv(className) {
      var div = document.createElement("div");
      var classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }
    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode;
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      wrapper = createDiv("navigation-wrapper");
      !mainSlider
        ? wrapper.setAttribute(
            "class",
            "lg:flex lg:flex-col lg:gap-5 navigation-wrapper h-max md:h-[unset] overflow-hidden"
          )
        : "";
      slider.container.parentNode.appendChild(wrapper);
      wrapper.appendChild(slider.container);
    }
    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }
      dots = createDiv("dots");
      dots.setAttribute(
        "class",
        `flex gap-6 justify-center items-center ${
          !mainSlider
            ? "border-t-[#7F7F7F] border-t-[1px] md:border-t-[0px] pt-5"
            : ""
        }`
      );
      slider.track.details.slides.forEach((_e, idx) => {
        var dot = createDiv("dot");
        dot.setAttribute(
          "class",
          `bg-[transparent] text-[12px] font-normal leading-[17px] text-center  ${
            !mainSlider
              ? "text-[#fff] hidden md:hidden [&.dot--active]:block decoration-[transparent]"
              : "text-[#000] hidden md:block [&.dot--active]:block"
          } decoration-[transparent] md:decoration-[#000] underline cursor-pointer [&.dot--active]:decoration-[2px] underline-offset-2`
        );
        dot.innerText = `${
          idx + 1 < 10
            ? Number(idx + 1)
                .toString()
                .padStart(2, "0")
            : idx + 1
        }`;
        dot.insertAdjacentHTML(
          "beforeend",
          `<span class="${!mainSlider ? "hidden" : "md:hidden"}"> / ${
            slider.track.details.slides.length < 10
              ? Number(slider.track.details.slides.length)
                  .toString()
                  .padStart(2, "0")
              : slider.track.details.slides.length
          }</span>`
        );
        !mainSlider
          ? dot.insertAdjacentText(
              "beforeend",
              ` - ${
                slider.track.details.slides.length < 10
                  ? Number(slider.track.details.slides.length)
                      .toString()
                      .padStart(2, "0")
                  : slider.track.details.slides.length
              }`
            )
          : "";
        dot.addEventListener("click", () => slider.moveToIdx(idx));
        dots.appendChild(dot);
      });
      wrapper.appendChild(dots);
    }
    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }
      arrowLeft = createDiv("arrow arrow--left");
      arrowLeft.innerHTML = arrowLeftSvg;
      arrowLeft.setAttribute(
        "class",
        "absolute top-[unset] bottom-[0px] left-[0px] cursor-pointer"
      );
      arrowLeft.addEventListener("click", () => slider.prev());
      arrowRight = createDiv("arrow arrow--right");
      arrowRight.innerHTML = arrowRightSvg;
      arrowRight.setAttribute(
        "class",
        "absolute top-[unset] bottom-[0px] right-[0px] cursor-pointer"
      );
      arrowRight.addEventListener("click", () => slider.next());

      wrapper.appendChild(arrowLeft);
      wrapper.appendChild(arrowRight);
    }
    function updateClasses() {
      var slide = slider.track.details.rel;
      Array.from(dots.children).forEach(function (dot, idx) {
        idx === slide
          ? dot.classList.add("dot--active")
          : dot.classList.remove("dot--active");
      });
    }
    slider.on("created", () => {
      markup();
      updateClasses();
      observer.observe(slider.container);
      //if (mainSlider) updateHeight();
    });
    slider.on("optionsChanged", () => {
      markup(true);
      markup();
      updateClasses();
    });
    slider.on("slideChanged", () => {
      updateClasses();
      // Get a reference to the button
    });
    slider.on("destroyed", () => {
      markup(true);
    });
  }
};
